import React from 'react';
import Select from 'react-select';
import { Async } from 'react-select';
import { injectIntl } from 'react-intl';
import { iFMessage } from '../../hoc/IntlComponents';

const SelectWithPlaceHolder = ({
    intl,
    placeholderId,
    noResultsTextId,
    searchPromptTextId,
    loadingPlaceholderId,
    asyncSearch,
    ...rest
}) => {
    const selectProps = {
        placeholder: iFMessage({intl, id: 'main.select'}),
        noResultsText: iFMessage({intl, id: 'main.nothing-found'}),
        searchPromptText: iFMessage({intl, id: 'main.type-to-search'}),
        loadingPlaceholder: iFMessage({intl, id: 'main.loading'}),
    };
    if(placeholderId) {
        selectProps.placeholder =
            iFMessage({intl, id: placeholderId});
    }
    if(noResultsTextId) {
        selectProps.noResultsText =
            iFMessage({intl, id: noResultsTextId}) + ' ' + iFMessage({intl, id: 'main.not-found'});
    }
    if(searchPromptTextId) {
        selectProps.searchPromptText =
            iFMessage({intl, id: searchPromptTextId});
    }
    if(loadingPlaceholderId) {
        selectProps.loadingPlaceholder =
            iFMessage({intl, id: loadingPlaceholderId});
    }
    if(!asyncSearch) {
        return <Select {...rest} {...selectProps} />;
    } else {
        return <Async {...rest} {...selectProps} />;
    }
};

export default injectIntl(SelectWithPlaceHolder);